import type { JSX } from 'react'

export const MicrophoneIcon = (): JSX.Element => (
  <use href='#microphoneIcon' height='100%' width='100%' />
)
